"use strict";

exports.__esModule = true;
var _ProfilePermissionsContext = require("./ProfilePermissionsContext");
Object.keys(_ProfilePermissionsContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProfilePermissionsContext[key]) return;
  exports[key] = _ProfilePermissionsContext[key];
});
var _ProfilePermissionsController = require("./ProfilePermissionsController");
Object.keys(_ProfilePermissionsController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProfilePermissionsController[key]) return;
  exports[key] = _ProfilePermissionsController[key];
});